var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"news-badge-container"},[_c('v-badge',{attrs:{"value":_vm.value,"color":_vm.color,"dot":_vm.dot,"content":_vm.text,"inline":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }